exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".involvedParty .btn{margin-right:20px;height:40px;width:40px}.involvedParty .input{margin:20px}.involvedParty .involvedPartiesGroup{border-radius:5px;border:5px}", ""]);

